// @ts-ignore
import AceIdentity, { AceIdentityEnv } from '@ace-clublabs/ace-identity';

export const createAceIdentity = (host: string, redirectPath: string) => {
  let aceIdentityEnv: AceIdentityEnv;
  let loginUrl: string;

  switch (true) {
    case host.includes('appdev2'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appdev2.ace.aaa.com/enterprise/identity/dev/#/login`;
      break;
    case host.includes('appqa2'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appqa2.ace.aaa.com/enterprise/identity/qa/#/login`;
      break;
    case host.includes('appuat2'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appuat2.ace.aaa.com/enterprise/identity/uat/#/login`;
      break;
    case host.includes('appdev'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appdev1.ace.aaa.com/enterprise/identity/dev/#/login`;
      break;
    case host.includes('appqa'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appqa1.ace.aaa.com/enterprise/identity/qa/#/login`;
      break;
    case host.includes('appuat'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appuat1.ace.aaa.com/enterprise/identity/uat/#/login`;
      break;
    case host.includes('account.app.uat'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appuat1.ace.aaa.com/enterprise/identity/uat/#/login`;
      break;
    case host.includes('membership.app.ace.aaa.com'):
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appdev1.ace.aaa.com/enterprise/identity/dev/#/login`;
      break;
    case host.includes('app.'):
      aceIdentityEnv = AceIdentityEnv.Prod;
      loginUrl = `https://app.ace.aaa.com/enterprise/identity/#/login`;
      break;
    default:
      aceIdentityEnv = AceIdentityEnv.NonProd;
      loginUrl = `https://appdev1.ace.aaa.com/enterprise/identity/dev/#/login`;
  }

  return new AceIdentity({
    env: aceIdentityEnv,
    redirectUri: `https://${host}${redirectPath}`,
    loginUrl: loginUrl || `https://${host}/enterprise/identity/${aceIdentityEnv.toLowerCase()}/#/login`,
    scopes: ['profile', 'clubCode', 'scope', 'openid', 'customerId', 'membershipStatus'],
    bypassAuth2: true,
    disableBypassPkce: true,
  });
};
